export default defineAppConfig({
  ui: {
    colors: {
      // Couleurs Tailwind standard (Nuxt UI v3 ne supporte que les couleurs Tailwind par défaut)
      primary: 'djust',       // Bleu Tailwind
      secondary: 'teal',   // Violet Tailwind
      
      // Couleurs système
      neutral: 'slate',
      success: 'emerald',
      info: 'sky',
      warning: 'amber',
      error: 'rose',
    },
  },
});
